import userData from './DefaultUserData'
import websocket from './WebsocketConnection'
import { v4 as uuidv4 } from 'uuid';

export default {
    downloadData() {
        // const data = localStorage.getItem('playerData')
        // return JSON.stringify(data)
        var obj = localStorage.getItem('playerData')
        // var data = "text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(obj));
        var data = JSON.stringify(obj);
        // what to return in order to show download window?
        console.log(obj)

        var fileDownload = require('js-file-download');
        fileDownload(data, 'FichaKaijuRPG.json', "application/json;charset=utf-8");

        // el.setAttribute("href", "data:" + data);
        // el.setAttribute("download", "data.json");
    },
    async updateData(data) {

        console.log(data)
        const newData = JSON.stringify(data)
        localStorage.setItem('playerData', newData)
    },
    getData() {
        return JSON.parse(localStorage.getItem('playerData'))
    },
    getName() {
        const data = JSON.parse(localStorage.getItem('playerData'))
        return data.info.nome
    },
    getPlayerId() {
        let id = localStorage.getItem('playerUuid')
        if (id == null) {
            id = uuidv4()
            localStorage.setItem('playerUuid', id);
        }

        return id
    },
    updateDataFromFile(data) {
        localStorage.setItem('playerData', data)
    },
    resetData() {
        const newData = JSON.stringify(userData)
        localStorage.setItem('playerData', newData)
    },
    getRoom() {
        const room = sessionStorage.getItem('room') || 'rpgkaiju'
        return room
    },
    setRoom(room) {
        sessionStorage.setItem('room', room)
    },
    test() {
    },
}